import Anavbar from '../Anavbar';

export default {
  name: 'Atags',
  render() {
    const { ...attrs } = this.$attrs;
    const { ...on } = this.$listeners;
    return (<Anavbar class="a-tags" {...{ attrs }} {...{ on }} />);
  }
}